import { mapState, mapActions, mapMutations } from 'vuex';
import { Money } from "v-money";

import AppGravarVisitaDialog from "./dialogs/GravarVisitaDialog.vue";
import AppSelecionarImovelDialog from "./dialogs/SelecionarImovelDialog.vue";
import AppGerarProposta from "./dialogs/GerarProposta.vue";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFileImport, faHourglassHalf, faThermometerEmpty, faThermometerQuarter, faThermometerHalf, faThermometerThreeQuarters, faThermometerFull, faToilet, faBed, faCar, faBuilding, faFileSignature } from '@fortawesome/free-solid-svg-icons';

import { AREA_PESQUISA_IMOVEL, TIPOS_IMOVEIS, ESTADOS, TIPOS_MIDIA, STATUS_ATENDIMENTO, ESTAGIO_ATENDIMENTO, TIPO_ACAO_PROPOSTA, AUTH_MODE_ZAP_SIGN } from '../../util/constantes.js'
import Util from '../../util/funcoes.js'

library.add(faHourglassHalf, faFileImport, faThermometerEmpty, faThermometerQuarter, faThermometerHalf, faThermometerThreeQuarters, faThermometerFull, faToilet, faBed, faCar, faBuilding, faFileSignature)

export default {
  components: {
    AppGravarVisitaDialog,
    AppSelecionarImovelDialog,
    AppGerarProposta,
    Money,
    FontAwesomeIcon
  },
  data() {
    return {
      exbibirDetalhes: false,
      indiceSelecionado: 1,

      loadingCidades: false,
      loadingBairros: false,
      loadingAtendente: false,

      visibilidadeGravarVisitaDialog: false,
      visibilidadeSelecionarImovelDialog: false,
      visibilidadeGerarPropostaDialog: false,
      visibilidadeFiltrosDrawer: false,

      cidadesDisponiveis: [],
      bairrosDisponiveis: [],
      atendentesDisponiveis: [],
      imoveisSelecionadosVisita: [],
      visitasExpandidas: [],
      loading: {},

      visita: {
        cliente: {
          id: 0,
          nome: ""
        },
        usuario: {
          id: 0,
          nome: ""
        }
      },

      validacaoPreCadastro: {
        cliente: [
          { type: "object", required: true,
            fields: {
              nome: { type: "string", required: true }
            }
          }
        ],
        usuario: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        midia: [ { type: "string", required: true } ]
      },

      validacaoCriacaoPerfil: {
        tipoImovel: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        estado: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        cidade: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      visibilidadeFiltros: false,
      
      loadingClientes: false,

      estagiosNavegacao: {
        preCadastro: {
          right: 'CRIACAO_PERFIL'
        },
        criacaoPerfil: {
          right: 'SELECAO_IMOVEIS',
          left: 'PRE_CADASTRO',
        },
        selecaoImoveis: {
          right: 'VISITAS',
          left: 'CRIACAO_PERFIL'
        },
        visitas: {
          right: 'PROPOSTAS',
          left: 'SELECAO_IMOVEIS'
        },
        propostas: {
          left: 'VISITAS'
        }
      },
      imovelProposta: undefined,
      clienteProposta: undefined,

      propostaSelecionada: {}
    }
  },
  created() {
    this.pesquisar();
  },
  computed: {
    ...mapState("loginStore", {
        usuarioLogado(state) { return state.usuarioLogado },
        permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "PRETENDENTES" })[0] }
    }),
    ...mapState('parametrosStore', {
      parametros(state) { return state.parametros }
    }),
    ...mapState("vendasAtendimentosStore", {
      atendimentos(state) { return state.listaAtendimentos },
      atendimentoPesquisa(state) { return state.atendimentoPesquisa },
      atendimento(state) { return state.atendimentoSelecionado },
      estagioAtualNavegacao(state) { return state.estagioAtualNavegacao },
      listaClientes(state) { return state.listaClientesSelect },
      propostaConcluida(state) { return state.propostaConcluida }
    }),

    exibirBotaoSelecionarImovel() {
      return ((this.atendimento.estagio == 'SELECAO_IMOVEIS' || this.atendimento.estagio == 'VISITAS') && this.imoveisSelecionadosVisita.length == 0);
    },
    exibirBotaoMarcarVisita() {
      return ((this.atendimento.estagio == 'SELECAO_IMOVEIS' || this.atendimento.estagio == 'VISITAS') && this.imoveisSelecionadosVisita.length > 0);
    },

    preCadastro() { return this.atendimentos.filter((atendimento) => { return atendimento.estagio == "PRE_CADASTRO" }) },
    criacaoPerfil() { return this.atendimentos.filter((atendimento) => { return atendimento.estagio == "CRIACAO_PERFIL" }) },
    selecaoImovel() { return this.atendimentos.filter((atendimento) => { return atendimento.estagio == "SELECAO_IMOVEIS" }) },
    visitas() { return this.atendimentos.filter((atendimento) => { return atendimento.estagio == "VISITAS" }) },

    estagioAtual() {
      switch(this.atendimento.estagio) {
        case "PRE_CADASTRO": return 0;
        case "CRIACAO_PERFIL": return 1;
        case "SELECAO_IMOVEIS": return 2;
        case "VISITAS": return 3;
        case "PROPOSTAS": return 4;
        default: return 5;
      }
    },

    preCadastroClass() {
      return {
        'el-current-card': this.estagioAtual == 0,
        'el-completed-card': this.estagioAtual > 0
      }
    },
    criacaoPerfilClass() {
      return {
        'el-incompleted-card': this.estagioAtual < 1,
        'el-current-card': this.estagioAtual == 1,
        'el-completed-card': this.estagioAtual > 1
      }
    },
    selecaoImovelClass() {
      return {
        'el-incompleted-card': this.estagioAtual < 2,
        'el-current-card': this.estagioAtual == 2,
        'el-completed-card': this.estagioAtual > 2
      }
    },
    visitasClass() {
      return {
        'el-incompleted-card': this.estagioAtual < 3,
        'el-current-card': this.estagioAtual == 3,
        'el-completed-card': this.estagioAtual > 3
      }
    },
    propostasClass() {
      return {
        'el-incompleted-card': this.estagioAtual < 4,
        'el-current-card': this.estagioAtual == 4,
        'el-completed-card': this.estagioAtual > 4
      }
    },

    preCadastroTitulo() { return "Pré-Cadastro (" + this.preCadastro.length + ")"; },
    criacaoPerfilTitulo() { return "Criação do Perfil (" + this.criacaoPerfil.length + ")"; },
    selecaoImovelTitulo() { return "Seleção do Imóvel (" + this.selecaoImovel.length + ")"; },
    visitasTitulo() { return "Visitas (" + this.visitas.length + ")"; },
    propostasTitulo() { return "Propostas (" + this.propostas.length + ")"; },

    area() { return AREA_PESQUISA_IMOVEL },
    estados() { return ESTADOS.filter(estado => { return estado.pais.id === 1 }); },
    tiposImoveis() { return TIPOS_IMOVEIS },
    tiposMidia() { return TIPOS_MIDIA },

    visualizarAtendimentosSomenteCorretor() { return this.permissoes.visualizacaoSomenteClientesCorretor },
    statusAtendimento() { return STATUS_ATENDIMENTO },
    estagioAtendimento() { return ESTAGIO_ATENDIMENTO },
    isLimiteLeft() { return this.estagioAtualNavegacao == 'PRE_CADASTRO' },
    isLimiteRight() { return this.estagioAtualNavegacao == this.atendimento.estagio || this.estagioAtualNavegacao === 'PROPOSTAS' },
    isAssinaturaAtiva() {
      return (this.usuarioLogado.imobiliaria.parametros.isActiveZapSign && this.parametros.tokenZapSign !== '')
    },

    isCadastrar() { return this.permissoes.cadastro },
    isAlteracao() { return this.permissoes.alteracao },
    isRemocao() { return this.permissoes.remocao },

    isAluguelHabilitado() { return this.usuarioLogado.imobiliaria.moduloAluguel },
    isVendaHabilitada() { return this.usuarioLogado.imobiliaria.moduloVenda },

    modoAutenticacao() { return AUTH_MODE_ZAP_SIGN }
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("cidadesStore", [
      "listarCidades"
    ]),
    ...mapActions("bairrosStore", [
      "listarBairros"
    ]),
    ...mapActions("usuariosStore", [
      "listarUsuarios"
    ]),
    ...mapActions("alugueisContratosStore", [
      "recuperarAluguel"
    ]),
    ...mapActions("vendasContratosStore", [
      "recuperarVenda"
    ]),
    ...mapActions("vendasAtendimentosStore",[
      "novoAtendimento",
      "listarAtendimentos",
      "recuperarAtendimento",
      "concluirPreCadastroAtendimento",
      "concluirCriacaoPerfilAtendimento",
      "gravarAvaliacaoVisita",
      "listarClientesSelect",
      "limparPesquisa",
      "enviarPropostaAssinatura",
      "removerAtendimento",
      "concluirProposta",
      'cancelarAtendimento',
      'cancelarAssinaturaProposta',
      'atualizarPreCadastro',
      'atualizarCriacaoPerfil',
      'removerImovelSemelhante',
      'enviarPropostaManualmente',
      'gerarPropostaManual',
      'cancelarProposta'
    ]),
    ...mapMutations("vendasAtendimentosStore", [
      "atualizarEstagioAtualNavegacao"
    ]),
    novo() {
      this.novoAtendimento();
      this.exbibirDetalhes = true;
      this.atendentesDisponiveis = [];
    },
    pesquisar() {
      this.showLoading();

        this.atendimentoPesquisa.usuario = {
            id: (this.visualizarAtendimentosSomenteCorretor ? this.usuarioLogado.id : 0)
        }

      this.listarAtendimentos(this.atendimentoPesquisa)
      .then(() => {
        this.hideLoading();
      }).catch(() => {

      });
    },
    recuperarHandler(atendimento) {
      let payload = { id: atendimento.id };
      this.recuperar(payload);
    },
    recuperar(payload) {
      this.showLoading();

      this.recuperarAtendimento(payload)
      .then((resultado) => {
        this.hideLoading();
        if(resultado.status == "SUCESSO") {
          this.atendentesDisponiveis = [resultado.item.usuario]
          this.cidadesDisponiveis = [resultado.item.cidade];
          this.bairrosDisponiveis = resultado.item.bairros;
          
          this.exbibirDetalhes = true;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    concluirPreCadastroHandler() {
      this.$refs["formPreCadastro"].validate((valid) => {
        if(valid) {
          this.concluirPreCadastro();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    concluirPreCadastro() {
      this.atendimento.estagio = "PRE_CADASTRO";

      this.showLoading();
      this.concluirPreCadastroAtendimento(this.atendimento)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);  
            break;
          default:
            this.$message.warning(resultado.mensagem);  
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    concluirCriacaoPerfilHandler() {
      this.$refs["formCriacaoPerfil"].validate((valid) => {
        if(valid) {
          this.concluirCriacaoPerfil();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    concluirCriacaoPerfil() {
      this.showLoading();

      this.concluirCriacaoPerfilAtendimento(this.atendimento)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);  
            break;
          default:
            this.$message.warning(resultado.mensagem);  
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    adicionarImoveisHandler() {
      this.exibirSelecionarImovelDialog();
    },
    exibirSelecionarImovelDialog() {
      this.visibilidadeSelecionarImovelDialog = true;
    },
    fecharSelecionarImovelDialog() { 
      this.visibilidadeSelecionarImovelDialog = false;
    },
    exibirGerarPropostaDialog(imovel) {
      this.imovelProposta = imovel
      this.visibilidadeGerarPropostaDialog = true;
    },
    fechargerarPropostaDialog() {
      this.visibilidadeGerarPropostaDialog = false
    },
    
    concluirSelecaoImovelHandler() {
      this.visita = {
        dataHora: Util.agora(),
        descricao: "",
        cliente: {
          id: this.atendimento.cliente.id,
          nome: this.atendimento.cliente.nome
        },
        usuario: {
          id: this.atendimento.usuario.id,
          nome: this.atendimento.usuario.nome
        },
        atendimento: {
          id: this.atendimento.id
        },
        imoveis: this.imoveisSelecionadosVisita
      }

      this.exibirGravarVisitaDialog();
    },

    marcarImovelVisita(val) {
      this.imoveisSelecionadosVisita = val;
    },

    voltar() {
      this.exbibirDetalhes = false;
      this.propostaSelecionada = {}
      this.pesquisar();
    },

    //VISITAS
    exibirGravarVisitaDialog() {
      this.visitaSelecionada = undefined;
      this.visibilidadeGravarVisitaDialog = true;
    },
    fecharGravarVisitaDialog() { 
      this.visitaSelecionada = undefined;
      this.visibilidadeGravarVisitaDialog = false;
    },
    gravarAvaliacaoHandler(visita, imovel) {
      let avaliacao = {
        id: visita.id,
        atendimento: { id: this.atendimento.id },
        imoveis: [{
          id: imovel.id,
          avaliacao: imovel.avaliacao,
          opiniaoCliente: imovel.opiniaoCliente
        }]
      }
      this.gravarAvaliacao(avaliacao);
    },
    gravarAvaliacao(avaliacao) {
      this.showLoading();

      this.gravarAvaliacaoVisita(avaliacao)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },

    //SELECT FUNCTIONS
    recuperarCidadesSelect(queryString) {
      if(this.atendimento.estado.id == 0) {
        this.$message.warning("Selecione o estado");
        return;
      }
      let payload = { nome: queryString, estado: { id: this.atendimento.estado.id } };
      
      this.loadingCidades = true;
      this.listarCidades(payload)
      .then((resultado) => {
        this.loadingCidades = false;
        this.cidadesDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingCidades = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    recuperarBairrosSelect(queryString) {
      if(this.atendimento.cidade.id == 0) {
        this.$message.warning("Selecione a cidade");
        return;
      }
      let payload = { nome: queryString, cidade: { id: this.atendimento.cidade.id } };

      this.loadingBairros = true;
      this.listarBairros(payload)
      .then((resultado) => {
        this.loadingBairros = false;
        this.bairrosDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingBairros = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    recuperarAtendentesSelect(queryString) {
      let payload = { nome: queryString };

      this.loadingAtendente = true;
      this.listarUsuarios(payload)
      .then((resultado) => {
        this.loadingAtendente = false;
        if(resultado.status == "SUCESSO") {
          this.atendentesDisponiveis = resultado.lista;
        }
      }).catch(() => {
        this.loadingAtendente = false;
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    //HELPER FUNCTIONS
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    coresTempoAtendimento(diasEstagioAtual) {
      if(diasEstagioAtual < 3) {
        return "#87CF87";
      } else if (diasEstagioAtual < 5) {
        return "#FFBC56";
      } else {
        return "#FF8686";
      }
    },
    getRowKey(row) {
      return row.id;
    },
    formatarLinha1Endereco(imovel) {
      if(imovel.imobiliaria.id == 0 && imovel.numeroEndereco) {
        return imovel.endereco + ", " + imovel.numeroEndereco;
      } else {
        return imovel.endereco;
      }
    },
    formatarLinhaImobiliaria(imobiliaria) {
      if(imobiliaria.id == 0) {
        return imobiliaria.nome;  
      } else if(imobiliaria.telefone && imobiliaria.celular) {
        return imobiliaria.nome + " - " + imobiliaria.telefone + " / " + imobiliaria.celular;
      } else if(imobiliaria.telefone) {
        return imobiliaria.nome + " - " + imobiliaria.telefone;
      } else if(imobiliaria.celular) {
        return imobiliaria.nome + " - " + imobiliaria.celular;
      }
      return "";
    },
    formatarLinha1EnderecoVisita(imovel) {
        return (imovel.complemento && imovel.complemento !== '' ? imovel.complemento + '-' : '') + imovel.endereco + ", " + imovel.numeroEndereco;
    },
    formatarLinha2EnderecoVisita(imovel) {
      return (imovel.condominio.nome !== undefined ? imovel.condominio.nome + " - " + imovel.bairro.nome + " - " + imovel.cidade.nome : imovel.bairro.nome + " - " + imovel.cidade.nome)
    },
    formatarValor(valor) {
      return Util.formatarValor(valor);
    },
    formatarPercentual(percentual) {
      return Util.formatarPercentual(percentual);
    },
    fonteImovelSemelhante(imobiliaria) {
      if(imobiliaria.id == 0) {
        return "bold";
      }
      return "normal"
    },
    formatarTelefones(cliente) {
      if(cliente.telefone && cliente.celular) {
        return cliente.telefone + " / " + cliente.celular;
      } else if(cliente.telefone) {
        return cliente.telefone;
      } else if(cliente.celular) {
        return cliente.celular;
      } else {
        return "Telefone não cadastrado";
      }
    },
    coresEstagios(estagio) {
      if(estagio < this.estagioAtual) {
        return "#67C23A";
      } else if(estagio == this.estagioAtual) {
        return "#008080";
      } else if (estagio > this.estagioAtual) {
        return "#C0C4CC";
      }
    },
    getLabelStatus(item) {
      return Util.getLabel(this.statusAtendimento, item)
    },
    getLabelEstagio(item) {
      return Util.getLabel(ESTAGIO_ATENDIMENTO, item)
    },
    getStatusColor(item) {
      switch (item) {
        case 'EM_ESPERA':
          return '#4587ec'
        case 'CANCELADO':
          return '#fb1111';
        case 'CONCLUIDO':
          return '#4dea00';
      }
    },

    getPorcentagemEstagio(item) {
      switch (item) {
        case 'PRE_CADASTRO':
          return 20;
        case 'CRIACAO_PERFIL':
          return 40;
        case 'SELECAO_IMOVEIS':
          return 60;
        case 'VISITAS':
          return 80;
        case 'PROPOSTAS':
          return 90;
        case 'CONCLUSAO':
          return 100;
      }
    },

    getModoAutenticacaoLabel(value) {
      return Util.getLabel(AUTH_MODE_ZAP_SIGN, value);
    },
    exibirFiltros() {
      this.visibilidadeFiltros = !this.visibilidadeFiltros
    },
    getStatusCadastro(atendimento) {
      if(atendimento.porcentagemConclusao === 100 && atendimento.status !== 'CANCELADO') {
        return 'success';
      } else if(atendimento.status === 'CANCELADO') {
        return 'exception';
      }
    },
    getStatusProcesso(atendimento) {
      if(atendimento.estagio === 'CONCLUSAO' && atendimento.status !== 'CANCELADO') {
        return 'success';
      } else if(atendimento.status === 'CANCELADO') {
        return 'exception';
      }
    },
    getLabelAcaoProposta(acao) {
      return Util.getLabel(TIPO_ACAO_PROPOSTA, acao)
    },
    filtrarClientesSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingClientes = true;
      this.listarClientesSelect(payload)
      .then(() => {
        this.loadingClientes = false;
      })
    },
    aplicarFiltros() {
      this.pesquisar();
      this.visibilidadeFiltros = false;
    },

    previous() {
      switch (this.estagioAtualNavegacao) {
        case 'PRE_CADASTRO':
          break;
        case 'CRIACAO_PERFIL':
          this.atualizarEstagioAtualNavegacao(this.estagiosNavegacao.criacaoPerfil.left)
          break;
        case 'SELECAO_IMOVEIS':
          this.atualizarEstagioAtualNavegacao(this.estagiosNavegacao.selecaoImoveis.left)
          break;
        case 'VISITAS':
          this.atualizarEstagioAtualNavegacao(this.estagiosNavegacao.visitas.left)
          break;
        case 'PROPOSTAS':
          this.atualizarEstagioAtualNavegacao(this.estagiosNavegacao.propostas.left);
          break;
        default:
          break;
      }
    },

    next() {
      switch (this.estagioAtualNavegacao) {
        case 'PRE_CADASTRO':
          this.atualizarEstagioAtualNavegacao(this.estagiosNavegacao.preCadastro.right);
          break;
        case 'CRIACAO_PERFIL':
          this.atualizarEstagioAtualNavegacao(this.estagiosNavegacao.criacaoPerfil.right);
          break;
        case 'SELECAO_IMOVEIS':
          this.atualizarEstagioAtualNavegacao(this.estagiosNavegacao.selecaoImoveis.right);
          break;
        case 'VISITAS':
          this.atualizarEstagioAtualNavegacao(this.estagiosNavegacao.visitas.right);
          break;
        case 'PROPOSTAS':
          this.atualizarEstagioAtualNavegacao(this.estagiosNavegacao.propostas.left);
          break;
        default:
          break;
      }
    },

    enviarProposta(proposta) {
      if(proposta.modoAutenticacao === 'SEM_AUTENTICACAO') {
        this.enviarPropostaManualmentHandler(proposta);
      } else {
        this.enviarPropostaAssinaturaHandler(proposta);
      }
    },

    enviarPropostaAssinaturaHandler(proposta) {
      const payload = {
        tipo: 'PROPOSTA',
        proposta: {
          ...proposta,
          atendimento: this.atendimento
        }
      }

      this.showLoading();
      this.enviarPropostaAssinatura(payload)
      .then(resposta => {
        if(resposta.status === 'SUCESSO') {
          this.$message.success('Proposta enviada com sucesso');
        }
        if(resposta.status === 'FALHA') {
          this.$message.warning(resposta.mensagem)
        }
      }).catch(error => {
        this.$message.error('Ocorreu um erro ao comunicar-se com o servidor!');
        throw error;
      }).finally(() => {
        this.hideLoading();
      })
    },

    concluirPropostaManual(proposta) {
      const payload = {
        ...this.atendimento,
        propostas: [
          {...proposta, atendimento: this.atendimento}
        ]
      }

      this.showLoading();
      this.concluirProposta(payload)
      .then((resposta) => {
        if(resposta.status === 'SUCESSO') {
          this.$message.success(resposta.mensagem);
        }
        if(resposta.status === 'FALHA') {
          this.$message.warning('Ocorreu uma falha.')
        }
      }).catch(error => {
        this.$message.error('Ocorreu um erro ao comunicar-se com o servidor!');
        throw error;
      }).finally(() => {
        this.hideLoading();
      })
    },

    removerAtendimentoHandler(atendimento) {
      this.$confirm('Deseja realmente remover este atendimento?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.showLoading();

        this.removerAtendimento({ id: atendimento.id })
        .then(resposta => {
          if(resposta.status === 'SUCESSO') {
            this.pesquisar();
            this.$message.success('Atendimento excluído com sucesso')
          }
          if(resposta.status === 'FALHA') {
            this.$message.warning('Ocorreu uma falha.')
          }
        }).catch(error => {
          this.$message.error('Ocorreu um erro ao comunicar-se com o servidor!');
          throw error;
        }).finally(() => {
          this.hideLoading();
        })
      }).catch(() => {})
    },
    
    redirecionarParaAluguel(aluguel) {
      this.showLoading();
      
      this.recuperarAluguel(aluguel)
      .then(resposta => {
        if(resposta.status === 'SUCESSO') {
          this.$router.push('/alugueis')
        }

        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Não foi possível recuperar o contrato.");
        this.hideLoading();
      })
    },

    redirecionarParaVenda(venda) {
      this.showLoading();
      
      this.recuperarVenda(venda)
      .then(resposta => {
        if(resposta.status === 'SUCESSO'){
          this.$router.push('/vendas');
        }

        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Erro ao se comunicar com o servidor");
        this.hideLoading();
      })
    },

    diasAteVencerProposta(dataValidade) {
      const dateDataValidade = Util.stringParaData(dataValidade);

      const diffEmMilissegundos = Math.abs(dateDataValidade - new Date());
      const diffEmDias = Math.ceil(diffEmMilissegundos / (1000 * 60 * 60 * 24));

      return `${diffEmDias} ${diffEmDias === 1 ? 'dia' : 'dias'}`
    },

    cancelarAtendimentoHandler() {
      this.$confirm("Deseja realmente considerar este atendimento como falha?", "Atenção", {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
      }).then(() => {
        this.showLoading();
        
        this.cancelarAtendimento(this.atendimento)
        .then((resposta) => {
          if(resposta.status === 'SUCESSO') {
            this.$message.success(resposta.mensagem);
          }

          this.hideLoading();
        }).catch(() => {
          this.$message.error("Erro ao se comunicar com o servidor")
          this.hideLoading();
        });
      }).catch(() => {})
    },

    cancelarAssinaturaPropostaHandler() {
      this.showLoading();

      const payload = {
        ...this.propostaAguardandoAssinatura,
        atendimento: this.atendimento
      }

      this.cancelarAssinaturaProposta(payload)
      .then((resposta) => {
        if(resposta.status === 'SUCESSO') {
          this.$message.success(resposta.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Erro ao se comunicar com o servidor");
        this.hideLoading();
      });
    },


    cancelarPropostaHandler(proposta, index) {
      this.showLoading();

      const payload = {
        ...proposta,
        index: index
      }

      this.cancelarProposta(payload)
      .then(resposta => {
        switch (resposta.status) {
          case 'SUCESSO':
            this.$message.success(resposta.mensagem);
            break;
          case 'ERRO':
            this.$message.success(resposta.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.')
      }).finally(() => {
        this.hideLoading();
      })
    },

    atualizarPreCadastroHandler() {
      this.showLoading();

      this.atualizarPreCadastro(this.atendimento) 
      .then((resposta) => {
        if(resposta.status === 'SUCESSO') {
          this.$message.success(resposta.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Erro ao se comunicar com o servidor")
      })
    },

    atualizarCriacaoPerfilHandler() {
      this.showLoading();

      this.atualizarCriacaoPerfil(this.atendimento)
      .then((resposta) => {
        if(resposta.status === 'SUCESSO') {
          this.$message.success(resposta.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Erro ao se comunicar com o servidor")
      })
    },

    removerImovelSemelhanteHandler(item, index) {
      this.$confirm('Deseja realmente remover este imóvel da lista?', 'Atenção', {
        confirmButtonText:'Confirmar',
        cancelButtonText:'Cancelar',
        type: 'warning'
      }).then(() => {
        const payload = {
          id: this.atendimento.id,
          imoveisSemelhantes: [item]
        }
  
        this.showLoading();
        this.removerImovelSemelhante(payload)
        .then(resposta => {
          if(resposta.status === 'SUCESSO') {
            this.atendimento.imoveisSemelhantes.splice(index, 1);
            this.$message.success(resposta.mensagem);
          }
  
          if(resposta.status === 'ERRO') {
            this.$message.error(resposta.mensagem);
          }
        }).catch(() => {
          this.$message.error('Erro ao comunicar-se com o servidor.')
        })

        this.hideLoading();
      }).catch(() => {});

    },

    enviarPropostaManualmentHandler(proposta) {
      const payload = {
        ...this.atendimento,
        propostas: [
          proposta
        ]
      }

      this.showLoading();
      this.enviarPropostaManualmente(payload)
      .then(response => {
        switch (response.status) {
          case 'SUCESSO':
            this.$message.success(response.mensagem)
            break;
          case 'FALHA':
            this.$message.warning(response.mensagem)
            break;
          default:
            this.$message.error(response.mensagem)
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor');
      })

      this.hideLoading();
    },

    gerarPropostaManualHandler(proposta) {
      this.showLoading();

      this.gerarPropostaManual(proposta)
      .then(response => {
        switch (response.status) {
          case "SUCESSO":
            window.open(response.mensagem, '_blank')
            break;
          case "FALHA":
            this.$message.warning(response.mensagem)
            break;
          default:
            this.$message.error(response.mensagem);
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor');
      })

      this.hideLoading();
    },

    termometroPercepcaoDoUsuario(porcentagem) {
      if(porcentagem < 25) {
        return 'thermometer-empty';
      } else if(porcentagem >= 25 && porcentagem < 50) {
        return 'thermometer-quarter';
      } else if(porcentagem >= 50 && porcentagem < 75) {
        return 'thermometer-half';
      } else if(porcentagem >= 75 && porcentagem < 100) {
        return 'thermometer-three-quarters';
      } else {
        return 'thermometer-full';
      }
    },

    showDetalhesProposta(proposta) {
      this.propostaSelecionada = proposta
    }
  }
}